import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  Paper,
  Box,
  CircularProgress,
  Pagination,
  Grid,
  Typography,
  Stack
} from '@mui/material';
import { api } from 'src/Api';
import { TableNoData } from 'src/components/NoData';
import palette from 'src/theme/palette';
import Searchbar from '../dashboard/Searchbar';
import Iconify from 'src/components/Iconify';
import { LoadingButton } from '@mui/lab';

const ProjectUserList = ({ open, onClose, projectId }) => {
  const token = localStorage.getItem('token');
  const [loading, setloading] = useState(false);
  const [list, setlist] = useState([]);
  const [pagination, setPagination] = useState({});
  const [search, setsearch] = useState('');

  useEffect(() => {
    if (search.length == 0) {
      list.length = 0;
      getProjectUserList(1);
    }
  }, [search]);

  function getProjectUserList(page) {
    setloading(true);
    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);

    const queryParams = new URLSearchParams();
    page && queryParams.append('page', page);
    search.length > 0 && queryParams.append('search', search);
    projectId && queryParams.append('id', projectId);

    const requestOptions = {
      method: 'GET',
      redirect: 'follow',
      headers: myHeaders
    };

    fetch(`${api.get_users_by_project_id}?${queryParams.toString()}`, requestOptions)
      .then((response) => {
        if (response.status === 200) {
          return response.text();
        } else {
          throw new Error('Failed to fetch Deal data');
        }
      })
      .then((result_) => {
        const result = JSON.parse(result_);
        setlist(result?.data);
        setPagination(result.pagination);
      })
      .catch((error) => {
        console.log('error', error);
      })
      .finally(() => {
        setloading(false);
      });
  }

  //   const handlePageChange = (event, newPage) => {
  //     setPagination((prev) => ({ ...prev, current_page: newPage }));
  //   };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle sx={{ fontFamily: 'poppinsMedium' }}>Active User List</DialogTitle>
      <DialogContent dividers>
        {!loading && (
          <>
            <Grid container spacing={2} alignItems="center" mb={3}>
              {/* Search + Search Button */}
              <Grid item xs={12} md={11}>
                <Grid container spacing={2} alignItems="center">
                  {/* Searchbar */}
                  <Grid item xs={12} sm={9} md={11}>
                    <Searchbar
                      width="100%"
                      value={search}
                      setFunction={(val) => setsearch(val)}
                      className="width_full_property"
                      placeholder="Search..."
                      onEnter={() => {
                        list.length = 0;
                        getProjectUserList(1);
                      }}
                    />
                  </Grid>

                  {/* Search Button */}
                  <Grid item xs={12} sm={3} md={1}>
                    <LoadingButton
                      fullWidth
                      sx={{ height: 33, borderRadius: 0.7 }}
                      variant="contained"
                      onClick={() => {
                        getProjectUserList(1);
                      }}
                    >
                      <Iconify icon="material-symbols:search" sx={{ width: 20, height: 20 }} />
                    </LoadingButton>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            {list.map((val) => {
              return (
                <Stack
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    mb: 1,
                    borderBottom: 1,
                    borderColor: palette.primary.inputborder,
                    pb: 1
                  }}
                >
                  <Box sx={{ display: 'flex', flex: 1, flexDirection: 'column' }}>
                    <Typography
                      sx={{
                        fontSize: 13,
                        color: palette.primary.titledark,
                        fontFamily: 'poppinsSemiBold'
                      }}
                    >
                      {val?.firstname + ' ' + val?.lastname}
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: 11,
                        color: palette.primary.title,
                        fontFamily: 'poppinsRegular'
                      }}
                    >
                      {val?.email}
                    </Typography>
                  </Box>
                  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                    <Typography
                      sx={{
                        fontSize: 12,
                        color: palette.primary.main,
                        fontFamily: 'poppinsSemiBold',
                        backgroundColor: palette.primary.lighterMain,
                        padding: '1px 15px',
                        borderRadius: 10,
                        letterSpacing: 0.5,
                        mb: 0.5
                      }}
                    >
                      {val?.role?.role_name}
                    </Typography>
                    <Typography
                      sx={{ fontFamily: 'poppinsLight', ml: 1 }}
                      className={
                        (val?.status?.toLowerCase() == 'active' && 'status-green-small') ||
                        (val?.status?.toLowerCase() == 'pending' && 'status-pending-small') ||
                        (val?.status?.toLowerCase() == 'expire' && 'status-red-small')
                      }
                    >
                      {val?.status.toLowerCase() == 'expire' ? 'EXPIRED' : val?.status}
                    </Typography>
                  </Box>
                </Stack>
              );
            })}
          </>
        )}

        {loading && (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 10.4 }}>
            <CircularProgress sx={{ color: palette.primary.main }} size={25} />
          </Box>
        )}

        {/* empty list */}
        {list.length == 0 && !loading && (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <TableNoData title="No User" sx={{ padding: 5, borderBottom: 0 }} />
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          variant="outlined"
          sx={{
            ml: 1.5,
            color: palette.primary.pageButtonTitle,
            borderColor: palette.primary.pageButtonBorder,
            fontSize: 12,
            height: 30,
            fontFamily: 'poppinsRegular',
            borderRadius: 0.7,
            '&:hover': {
              backgroundColor: palette.primary.inputborder,
              borderColor: palette.primary.pageButtonBorder
            }
          }}
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default ProjectUserList;
